export default {
	list: 'BulkUploadAudit',
	grid: {
		gridId: '',
		checkbox: true
	},
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			editable:false
		},
		FileName: {
			class: 'lookup',
			dataName: 'File/Name',
			type: 'string',
			title: 'File Name',
			width: 250,
			hidden: false
		},
		FileServerRelativeUrl: {
			class: 'lookup',
			dataName: 'File/ServerRelativeUrl',
			type: 'string',
			title: 'ServerRelativeUrl',
			width: 150,
			hidden: true,
			readOnly: true,
			editable:false
		},
		BulkUploadType: {
			dataName: 'BulkUploadType',
			type: 'string',
		}
	}
}